import React from 'react';
import PropTypes from 'prop-types';
import {FieldShape} from 'commons/shapes';
import {FormikErrors, withFormik} from 'formik';
import {DigitalizedSignatureValues} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import ConsigneeSign from './InnerFormConsigneeSign';
import {formValidator} from 'commons/utils/Functions';
import {Messages} from 'commons/constants';

ConsigneeSignForm.propTypes = {
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
    signature: PropTypes.any,
    signed: PropTypes.bool.isRequired,
    allowSign: PropTypes.bool.isRequired
};

const FormControl = withFormik<
    InferPropTypes<typeof ConsigneeSignForm.propTypes>,
    DigitalizedSignatureValues
>({
    mapPropsToErrors: () => {
        return {
            signature: '',
            informationCheck: '',
            signed: '',
        };
    },
    mapPropsToValues: (props) => {
        return {
            signature: props.signature || '',
            informationCheck: props.signature ? true : false,
            signed: props.signed,
        };
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: DigitalizedSignatureValues, props) => {
        const errors: FormikErrors<DigitalizedSignatureValues> = {};
        formValidator(props.fields, errors, values);
        if (!values.signature && props.allowSign) {
            errors.signature = Messages.SIGNATURE_NOT_CAPTURED;
        }
        if(!values.informationCheck && props.allowSign){
            errors.informationCheck = Messages.ACCEPT_THE_TERMS;
        }
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    }
})(ConsigneeSign);

function ConsigneeSignForm(props: InferPropTypes<typeof ConsigneeSignForm.propTypes>) {
    const {submitHandler, fields, signed, signature, allowSign} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            fields={fields}
            signed={signed}
            signature={signature}
            submitHandler={submitHandler}
            allowSign={allowSign}
        />
    );
}

export default ConsigneeSignForm;
